class RouteSummaryLineItemsRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteSummaryLineItems";

    super(entityName);

    var options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms.RouteSummaryLineItems) {
      App.Forms.RouteSummaryLineItems = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [],
        ordersIds: []
      };
    }

    if (!App.Objects.RouteSummaryLineItems) {
      App.Objects.RouteSummaryLineItems = this;
    }
  }

  getFieldsToGridLayout = callback => {
    var error = null,
      ajax = null,
      url = "form/RouteMonitorLineItem/index";

    try {
      ajax = new Monet.Ajax();
      ajax.url = url;
      ajax.success = data => {
        if (data) {
          App.Forms.RouteSummaryLineItems.layout["index"] = data;
        }
        if (callback) {
          callback();
        }
      };

      ajax.error = function(response) {
        Monet.Configurations.errorNotification(null, response);
      };

      ajax.send();
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on get grid layout on route monitoring route"
      );
      error.console();
    }
  };

  updateGrid = (filter, callback, appendCollection) => {
    var error = null;
    try {
      const dataProvider = App.Forms.RouteSummaryLineItems.dataProvider;
      const grid = App.Forms.RouteSummaryLineItems.table;

      if (filter.criteriaChain.length) {
        const columns = grid.getColumns();

        const lineItemsCollection = new App.Collections.LineItems();
        const projectionBuilder = new Monet.Builder.Projection();

        projectionBuilder.setLayout(
          JSON.parse(
            JSON.stringify(App.Forms.RouteSummaryLineItems.layout.index)
          )
        );
        projectionBuilder.parseLayout();
        projectionBuilder.projection.fields = projectionBuilder.projection.fields.map(
          field => {
            if (field.name !== "order") {
              field.name = "lineItems." + field.name;
            } else {
              // na projeção esse campo não pode ter comportamento de lookup.
              field.name = "number";
              field.type = "TEXT";
              field.lookupEntityColumn = "";
            }
            return field;
          }
        );

        dataProvider.arrayIds = [];

        if (appendCollection) {
          lineItemsCollection.reset();
        }

        const loading = new Monet.UI.LoadingData();
        loading.init();
        loading.show();

        lineItemsCollection.filterWithRestrictionsByHaveToMany({
          entityParentToUrl: "Order",
          attributeHasMany: "lineItems",
          attributeParent: "order",
          filter,
          criteria: projectionBuilder.projection.toString(),
          success: result => {
            if (callback) {
              callback(this.entityName, columns, result, false);
            }
            loading.hide();
          }
        });
      } else {
        dataProvider.setData([]);
        grid.invalidate();
        Monet.Grid.Utils.hideGridNoResult(this.entityName);
        Monet.Grid.Utils.showGridNoResult(this.entityName);
      }
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring route",
        e
      );
      error.console();
    }
  };

  getFilter = () => {
    const ordersId = App.Forms.RouteSummaryLineItems.ordersIds;
    const filter = {
      criteriaChain: [],
      sort: []
    };
    const columnToOrders = App.Forms.RouteSummaryLineItems.columnToOrders || [];

    if (ordersId && ordersId.length) {
      filter.criteriaChain = [
        {
          and: [
            {
              attr: "id",
              in: ordersId
            }
          ]
        }
      ];
    }

    columnToOrders.forEach(item => {
      const field =
        item.field === "order.number"
          ? item.field.replace("order.", "")
          : `lineItems.${item.field}`;
      filter.sort.push({
        attr: field,
        type: item.order
      });
    });

    return filter;
  };

  getCriteriaForCsvExporter = () => {
      const ordersId = App.Forms.RouteSummaryLineItems.ordersIds;
      const filter = {
        criteriaChain: [],
        sort: []
      };
      const columnToOrders = App.Forms.RouteSummaryLineItems.columnToOrders || [];
  
      if (ordersId && ordersId.length) {
        filter.criteriaChain = [
          {
            and: [
              {
                attr: "order.id",
                in: ordersId
              }
            ]
          }
        ];
      }
  
      columnToOrders.forEach(item => {
        const field =
          item.field === "order.number"
            ? item.field.replace("order.", "")
            : `lineItems.${item.field}`;
        filter.sort.push({
          attr: field,
          type: item.order
        });
      });
  
      return filter;
    };
  }

App.Routers.RouteSummaryLineItems = RouteSummaryLineItemsRouter;
